// components/ui/table/TableHeader.jsx
export const TableHeader = ({ children, className = "" }) => {
  return <thead className={`[&_tr]:border-b ${className}`}>{children}</thead>;
};
